import Api from '@/api/index'
import SessionHelper from '@/helpers/SessionHelper'

if (SessionHelper.isExpired()) {
  SessionHelper.clear()
}

const state = {
  token: SessionHelper.token,
  role: SessionHelper.role,
  fullName: SessionHelper.fullName,
  menu: SessionHelper.menu,
  roles: SessionHelper.roles,
  expiresAt: SessionHelper.expiresAt,
  distributor: SessionHelper.distributor,
}

const getters = {
  isLoggedIn: state => {
    if (state.token === null && state.role === null) {
      return false
    }
    return true
  },
  sessionUser: state => ({
    TOKEN: state.token,
    ROLE: state.role,
    FULL_NAME: state.fullName,
  }),
  sessionDistributor: state => state.distributor,
  userMenu: state => state.menu,
  userRoles: state => state.roles,
  isAdmin: state => {
    return state.roles.some(r => r.code === 'GEM')
  },
}

const actions = {
  async login({ commit }, creds) {
    const user = await Api.CurrentSession.login(creds.email, creds.upass)
    if (user !== null) {
      commit('logged', user.data)
      commit('updateLocalStorage', user.data)
      return user
    }
    return null
  },
  logout({ commit }) {
    commit('clearSession')
    commit('clearLocalStorage')
    return true
  },
}

const mutations = {
  logged(state, user) {
    state.token = user.token
    state.role = user.role
    state.fullName = user.fullName
    state.menu = user.menu || []
    state.roles = user.roles || []
    state.expiresAt = user.expiresAt ? new Date(user.expiresAt) : null
    state.distributor = user.distributor || null
  },

  updateLocalStorage(state, user) {
    SessionHelper.update(user)
  },

  clearSession(state) {
    state.token = null
    state.role = null
    state.fullName = null
    state.menu = []
    state.roles = []
    state.expiresAt = null
    state.distributor = null
  },

  clearLocalStorage() {
    SessionHelper.clear()
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
